import React, { useState, useRef } from 'react';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import SetDetails from 'src/common/organisms/setItemDetails';
// import ItemDetails from 'src/pages/scheduleSurgery/components/cart/itemDetails';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import NoInventoryShippingNonTissueSet from 'src/pages/scheduleSurgery/components/surgery/notifications/NoInventoryShippingNonTissueSet';
import ItemNotAvailable from 'src/pages/scheduleSurgery/components/surgery/notifications/ItemNotAvailable';
import useNonInitialRenderHook from 'src/common/hooks/useNonInitialRenderHook';
import { setAccountSearchOpen } from 'src/pages/more/redux/actions';
import {
    validateProducts,
    clearValidatedProducts,
} from 'src/pages/scheduleSurgery/redux/actions';
import {
    validateProducts as consignmentAddValidateProducts,
    clearValidatedProducts as consignmentAddClearValidatedProducts,
} from 'src/pages/consignmentAdd/redux/actions';
import {
    validateProducts as equityValidateProducts,
    clearValidatedProducts as clearEquityValidatedProducts,
} from 'src/pages/equity/redux/actions';
import {
    PRODUCTVALIDATIONPOPUPMESSAGES,
    PRODUCTVALIDATIONTEMPLATEPOPUPMESSAGES,
} from 'src/constants/productConstants';

import ThresholdAndCumulativeLimitError from 'src/pages/scheduleSurgery/components/surgery/notifications/ThresholdAndCumulativeLimitError';
import { useTranslation } from 'react-i18next';
import UnidRodCannotModifyNotification from 'src/pages/scheduleSurgery/components/surgery/notifications/UnidRodCannotModifyNotification';
import { checkNonTissueExtraItems, logErrorToConsole } from 'src/utils/util';
import ExclusionItemsNotAllowed from 'src/pages/scheduleSurgery/components/surgery/notifications/ExclusionItemsNotAllowed';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export default function SetItemModal({
    handleClose, // to close modal
    handleSetItemClick, // hanlder for selected item/set from modal
    selectedItem, // current selected item/set
    setDetails, // to show setdetails modal
    itemDetails, // to show itemdetails modal
    showBackText,
    backText,
    previousCfn,
    onBackClick,
    isFromQuickOrder,
    isOnlyPlusButton, //Boolean - show Add product Icon or not
    onOpen = () => {},
    onClose = () => {},
    removeExtraItem,
    zIndex = 0,
    marginTop,
    isEquity,
    height,
    templateType,
    moreTemplates,
    isConsignmentAdd,
    isSurgery,
    countryISOCode,
    id,
    isSurgeryTemplate,
    equityTemplate,
    setProductToBeAdded,
    setAdded,
    setRemoveExtraItemNotification,
    setPopUpsItems,
    isFromSurgery,
    isOrderDetail,
    hideThresholdPopup = false,
}) {
    const { t } = useTranslation();
    const [
        showItemNotAllowedAsExtraItemPopup,
        setShowItemNotAllowedAsExtraItemPopup,
    ] = useState(false);
    const [
        showSetNotAllowedAsExtraItemPopup,
        setShowSetNotAllowedAsExtraItemPopup,
    ] = useState(false);
    const dispatch = useDispatch();
    const [popupNotificationsStack, setPopupNotificationsStack] = useState([]);
    const [showItemNotAvailablePopup, setShowItemNotAvailablePopup] =
        useState(false);
    const [onlyNonTissueSets, setOnlyNonTissueSets] = useState(false);
    const [b33Popup, setB33Popup] = useState(false);
    const [
        thresholdAndCumulativeLimitError,
        setThresholdAndCumulativeLimitError,
    ] = useState({ error: false, errorText: '' });
    const orientationChangedRef = useRef(false);
    useEffectWithErrorLogging(() => {
        const handleOrientationChange = () => {
            orientationChangedRef.current = true;
        };
        window.addEventListener('orientationchange', handleOrientationChange);

        return () => {
            dispatch(setAccountSearchOpen(false));
            window.removeEventListener(
                'orientationchange',
                handleOrientationChange
            );
            // Only clear if not due to orientation change
            if (!orientationChangedRef.current) {
                setOnlyNonTissueSets(false);
                isConsignmentAdd
                    ? dispatch(consignmentAddClearValidatedProducts())
                    : isEquity
                    ? dispatch(clearEquityValidatedProducts())
                    : dispatch(clearValidatedProducts());
            }
        };
    }, []);

    const {
        validatedProduct,
        isExcluded,
        isExcludedExtraItem,
        productFamily,
        nonInventoryShipping,
        isB33Item,
        thresholdLimit,
        cumulativeLimit,
        thresholdLimitError,
        cumulativeLimitError,
        validatedProductSalesOrg,
        isCondensedView,
    } = useSelector(
        (state) => ({
            isCondensedView: state.loginReducer.isCondensedView,
            validatedProduct:
                state.validateProductsReducer?.validatedProducts[0],
            isExcluded: isEquity
                ? state.equityValidateProductsReducer?.validatedProducts[0]
                      ?.isExcluded ||
                  state.equityValidateProductsReducer?.validatedProducts[0]
                      ?.isExcludedExtraItem ||
                  false
                : isConsignmentAdd
                ? state.consignmentAddValidateProductsReducer
                      ?.validatedProducts[0]?.isExcluded ||
                  state.consignmentAddValidateProductsReducer?.validatedProducts[0]
                      ?.isExcludedExtraItem ||
                  false
                : state.validateProductsReducer?.validatedProducts[0]
                      ?.isExcluded ||
                  state.validateProductsReducer?.validatedProducts[0]
                      ?.isExcludedExtraItem ||
                  false,
            isExcludedExtraItem: isEquity
                ? state.equityValidateProductsReducer?.validatedProducts[0]
                      ?.isExcludedExtraItem
                : isConsignmentAdd
                ? state.consignmentAddValidateProductsReducer
                      ?.validatedProducts[0]?.isExcludedExtraItem || false
                : state.validateProductsReducer?.validatedProducts[0]
                      ?.isExcludedExtraItem ||
                  false,
            productFamily: isEquity
                ? state.equityValidateProductsReducer?.validatedProducts[0]
                      ?.productFamily?.length > 0
                    ? true
                    : false
                : isConsignmentAdd
                ? state.consignmentAddValidateProductsReducer
                      ?.validatedProducts[0]?.productFamily?.length > 0
                    ? true
                    : false
                : state.validateProductsReducer?.validatedProducts[0]
                      ?.productFamily?.length > 0 &&
                  !(
                      state.validateProductsReducer?.validatedProducts[0]
                          ?.isExcludedExtraItem ||
                      state.validateProductsReducer?.validatedProducts[0]
                          ?.isExcluded
                  )
                ? true
                : false,
            nonInventoryShipping: isEquity
                ? state.equityValidateProductsReducer?.validatedProducts[0]
                      ?.nonInventoryShipping || false
                : isConsignmentAdd
                ? state.consignmentAddValidateProductsReducer
                      ?.validatedProducts[0]?.nonInventoryShipping || false
                : state.validateProductsReducer?.validatedProducts[0]
                      ?.nonInventoryShipping || false,
            isB33Item:
                state.validateProductsReducer?.validatedProducts[0]
                    ?.isB33Item || false,
            thresholdLimitError:
                state.validateProductsReducer?.validatedProducts[0]
                    ?.thresholdLimitError || false,
            thresholdLimit:
                state.validateProductsReducer?.validatedProducts[0]
                    ?.thresholdLimit,
            cumulativeLimitError:
                state.validateProductsReducer?.validatedProducts[0]
                    ?.cumulativeLimitError || false,
            cumulativeLimit:
                state.validateProductsReducer?.validatedProducts[0]
                    ?.cumulativeLimit,
            validatedProductSalesOrg:
                state.validateProductsReducer?.validatedProducts[0]
                    ?.salesOrg,
        }),
        shallowEqual
    );

    // console.log("piknhilknd", salesOrg);
    useEffectWithErrorLogging(() => {
        if (popupNotificationsStack?.length !== 0) {
            if (popupNotificationsStack[0]?.nonInventoryShipping) {
                setOnlyNonTissueSets(true);
            } else if (popupNotificationsStack[0].isB33Item) {
                setB33Popup(true);
            } else if (
                popupNotificationsStack[0].isExcluded ||
                popupNotificationsStack[0].isExcludedExtraItem
            ) {
                if (validatedProduct?.isSet) {
                    setShowSetNotAllowedAsExtraItemPopup(true);
                } else {
                    isConsignmentAdd ? setShowItemNotAllowedAsExtraItemPopup(true) : 
                    setShowItemNotAvailablePopup(true);
                }
            } else if (
                popupNotificationsStack[0].productFamily &&
                !(
                    popupNotificationsStack[0].isExcludedExtraItem ||
                    popupNotificationsStack[0].isExcluded
                )
            ) {
                setShowItemNotAvailablePopup(productFamily);
            } else if (!hideThresholdPopup && popupNotificationsStack[0].thresholdLimitError) {
                setThresholdAndCumulativeLimitError({
                    error: true,
                    errorText: (popupNotificationsStack[0].salesOrg === 'S030'
                        ? t('common.thresholdLimitError')
                        : t('common.thresholdLimitErrorNonTissue')
                    ).replace(
                        '${thresholdLimit}',
                        thresholdLimit
                    ),
                });
            } else if (!hideThresholdPopup && popupNotificationsStack[0].cumulativeLimitError) {
                setThresholdAndCumulativeLimitError({
                    error: true,
                    errorText: (popupNotificationsStack[0].salesOrg === 'S030'
                        ? t('common.cumulativeLimitError')
                        : t('common.cumulativeLimitErrorNonTissue')
                    ).replace(
                        '${cumulativeLimit}',
                        cumulativeLimit
                    ),
                });
            }
        }
    }, [popupNotificationsStack]);
    // to identify whether an item is excluded or excluded extra item
    useNonInitialRenderHook(() => {
        const popups = [];
        if (
            nonInventoryShipping &&
            !isExcluded &&
            !isExcludedExtraItem &&
            !isB33Item
        ) {
            popups.push({ nonInventoryShipping: true });
        }
        if (isExcluded || (isExcludedExtraItem && !isB33Item)) {
            popups.push({ isExcluded: true });
        } else if (productFamily) {
            popups.push({ productFamily: true });
        }
        if (isB33Item) {
            popups.push({ isB33Item: true });
        }
        if (thresholdLimitError) {
            popups.push({ thresholdLimitError: true, salesOrg: validatedProductSalesOrg, thresholdLimit });
        }
        if (cumulativeLimitError) {
            popups.push({ cumulativeLimitError: true, salesOrg: validatedProductSalesOrg, cumulativeLimit });
        }

        // if (isExcludedExtraItem && !isB33Item) {
        //     popups.push({ isExcludedExtraItem: true });
        // }

        setPopupNotificationsStack(popups);
        // if (isExcluded || isExcludedExtraItem) {
        //     showSetDetails(false);
        //     showItemDetails(false);
        //     setPreviousItem('');
        // }
    }, [
        isExcluded,
        isExcludedExtraItem,
        productFamily,
        nonInventoryShipping,
        isB33Item,
        thresholdLimitError,
        cumulativeLimitError,
    ]);
    const updateTemplate = (item) => {
        if (isSurgeryTemplate || equityTemplate) {
            setProductToBeAdded({
                ...item,
                cfn: item.bom ? item.bom : item.cfn,
            });
            setAdded(false);
        }
    };
    const productValidation = (products) => {
        if (isEquity) {
            dispatch(
                equityValidateProducts({
                    products,
                    orderType: 'ZOR',
                    searchType: 'productSearch',
                })
            );
        } else if (isConsignmentAdd) {
            dispatch(
                consignmentAddValidateProducts({
                    products,
                    orderType: 'KB',
                    searchType: 'productSearch',
                })
            );
        } else {
            if (checkNonTissueExtraItems(removeExtraItem, products)) {
                setPopUpsItems(products);
                setRemoveExtraItemNotification(true);
            } else {
                dispatch(
                    validateProducts({
                        products,
                        orderType: 'ZLC',
                        searchType: 'productSearch',
                        isFromSurgery: !moreTemplates,
                    })
                );
            }
        }
    };
    return (
        <>
            {(setDetails || itemDetails) &&
            ((selectedItem.cfn != undefined && selectedItem.cfn != '') ||
                (selectedItem.bom != undefined && selectedItem.bom != '')) ? (
                <>
                    <ModalDialog
                        id={id}
                        modalHeight={'80vh'}
                        // modalWidth={'594px'}
                        maxWidth={'841px'}
                        zIndex={zIndex}
                        marginTop={marginTop}
                        padding="10px"
                        // height={isDetails ? '101.5%' : undefined}  //commented for Order Details
                        height={height ? height : '101.5%'}
                        handleClose={() => {
                            try {
                                handleClose(setDetails);
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                    >
                        <SetDetails
                            handleClose={() => {
                                try {
                                    handleClose(setDetails);
                                } catch (error) {
                                    logErrorToConsole(error);
                                }
                            }}
                            moreTemplates={moreTemplates ? true : false}
                            onItemClick={handleSetItemClick}
                            item={selectedItem}
                            onAddClick={(item) => {
                                dispatch(setAccountSearchOpen(true));
                                // Call the validation
                                productValidation([
                                    {
                                        ...item,
                                        ...(setDetails && {
                                            cfn: item.bom ? item.bom : item.cfn,
                                        }),
                                        productAdded: true,
                                        isAdded: true,
                                        added: true,
                                    },
                                ]);
                                updateTemplate(item);
                                setTimeout(() => {
                                    try {
                                        item.productAdded = false;
                                        item.isAdded = false;
                                        item.added = false;
                                    } catch (error) {
                                        logErrorToConsole(error);
                                    }
                                }, 1000);
                            }}
                            showBackText={showBackText}
                            backText={backText}
                            previousCfn={previousCfn}
                            onBackClick={onBackClick}
                            isOnlyPlusButton={isOnlyPlusButton}
                            onOpen={onOpen}
                            onClose={onClose}
                            isConsignmentAdd={isConsignmentAdd}
                            isEquity={isEquity}
                            isSetDetail={setDetails ? true : false}
                            id={id}
                            isOrderDetail={isOrderDetail}
                        />
                    </ModalDialog>
                </>
            ) : null}

            {/* Item not available or item not allowed as extra item notification popup */}
            {showItemNotAllowedAsExtraItemPopup && isExcludedExtraItem && (
                <ItemNotAvailable
                    headings={
                        isSurgery
                            ? // && (countryISOCode === 'US' || countryISOCode == 'JP')
                              PRODUCTVALIDATIONPOPUPMESSAGES()[
                                  'itemNotAllowedAsExtraSurgery'
                              ]
                            : isConsignmentAdd?
                            PRODUCTVALIDATIONPOPUPMESSAGES()[
                                  'itemNotAvailableConsignmentAdd'
                              ]
                            :
                            PRODUCTVALIDATIONPOPUPMESSAGES()[
                                  'itemNotAllowedAsExtra'
                              ]
                    }
                    onClose={() => {
                        try {
                            const popups = [...popupNotificationsStack];
                            popups.splice(0, 1);
                            setPopupNotificationsStack(popups);
                            setShowItemNotAllowedAsExtraItemPopup(false);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                />
            )}
            {showSetNotAllowedAsExtraItemPopup && isExcluded && isSurgery && (
                // (countryISOCode === 'US' || countryISOCode == 'JP') &&
                <ItemNotAvailable
                    headings={
                        PRODUCTVALIDATIONPOPUPMESSAGES()['setNotAllowedAsExtra']
                    }
                    onClose={() => {
                        try {
                            const popups = [...popupNotificationsStack];
                            popups.splice(0, 1);
                            setPopupNotificationsStack(popups);
                            setShowSetNotAllowedAsExtraItemPopup(false);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                />
            )}
            {showSetNotAllowedAsExtraItemPopup &&
                isExcludedExtraItem &&
                isSurgery && (
                    // (countryISOCode === 'US' || countryISOCode == 'JP') &&
                    <ItemNotAvailable
                        headings={
                            PRODUCTVALIDATIONPOPUPMESSAGES()[
                                'setNotAllowedAsExtra'
                            ]
                        }
                        onClose={() => {
                            try {
                                const popups = [...popupNotificationsStack];
                                popups.splice(0, 1);
                                setPopupNotificationsStack(popups);
                                setShowSetNotAllowedAsExtraItemPopup(false);
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                    />
                )}
            {showItemNotAvailablePopup &&
                !isFromQuickOrder &&
                !isFromSurgery &&
                !isSurgeryTemplate &&
                (isExcluded || productFamily) && (
                    // !isCondensedView &&
                    <ItemNotAvailable
                        headings={
                            isExcluded
                                ? PRODUCTVALIDATIONPOPUPMESSAGES()[
                                      'itemNotAllowedAsExtra'
                                  ]
                                : productFamily && templateType === 'SURGERY'
                                ? PRODUCTVALIDATIONTEMPLATEPOPUPMESSAGES()[
                                      'specialHandlingRequired'
                                  ]
                                : PRODUCTVALIDATIONPOPUPMESSAGES()[
                                      'specialHandlingRequired'
                                  ]
                        }
                        onClose={() => {
                            try {
                                const popups = [...popupNotificationsStack];
                                popups.splice(0, 1);
                                setPopupNotificationsStack(popups);
                                setShowItemNotAvailablePopup(false);
                                dispatch(clearEquityValidatedProducts());
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                        isProductFamily={productFamily}
                        templatePopupHeight={
                            productFamily &&
                            templateType === 'SURGERY' &&
                            '280px'
                        }
                        color={
                            productFamily &&
                            templateType === 'SURGERY' &&
                            '#130e4a'
                        }
                        fontFamily={
                            productFamily &&
                            templateType === 'SURGERY' &&
                            'AvenirNextWorld Demi'
                        }
                    />
                )}
            {/* Only non-tissue sets can be added */}
            {onlyNonTissueSets && (
                <NoInventoryShippingNonTissueSet
                    onClose={() => {
                        try {
                            const popups = [...popupNotificationsStack];
                            popups.splice(0, 1);
                            setPopupNotificationsStack(popups);
                            setOnlyNonTissueSets(false);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                />
            )}
            {b33Popup && (
                <UnidRodCannotModifyNotification
                    onClose={() => {
                        try {
                            const popups = [...popupNotificationsStack];
                            popups.splice(0, 1);
                            setPopupNotificationsStack(popups);
                            setB33Popup(false);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                />
            )}
            {/* threshold and cumilative limit exceed error */}
            {!hideThresholdPopup && thresholdAndCumulativeLimitError.error && (
                <ThresholdAndCumulativeLimitError
                    title={thresholdAndCumulativeLimitError.errorText}
                    onClose={() => {
                        try {
                            const popups = [...popupNotificationsStack];
                            popups.splice(0, 1);
                            setPopupNotificationsStack(popups);
                            setThresholdAndCumulativeLimitError({
                                error: false,
                                errorText: '',
                            });
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                />
            )}
        </>
    );
}
